const VALIDATION_MESSAGES = {
  'onlyOneCVAOption1': 'Please select only one option for installer verification.',
  'onlyOneCVAOption2': 'Please select only one option for inspector verification.',
  'outDoorCVAOneOption': 'Please select only one option for outdoor CVA.',

  'upperOrLower1': 'Please select only one option for upper or lower, vent 1',
  'upperOrLower2': 'Please select only one option for upper or lower, vent 2',
  'upperOrLower3': 'Please select only one option for upper or lower, vent 3',
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "cvaSufficient": () => ({
      validate: () => {
        const options = ["cvaSufficient", "cvaCorrected", "casFail"]
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['onlyOneCVAOption1']
      }
    }),
    "cvaSufficient2": () => ({
      validate: () => {
        const options = ["cvaSufficient2", "cvaCorrected2", "casFail2"]
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['onlyOneCVAOption2']
      }
    }),
    "upperOnlyDivideBy3": () => ({
      validate: () => {
        const options = ["upperOnlyDivideBy3", "upperAndLowerVerticalDivideBy4", "upperAndLowerHorizontalDivideBy2", "garageEnclosedPorchDivideBy4"]
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['outDoorCVAOneOption']
      }
    }),
    "vent1_isUpper": () => ({
      validate: () => {
        const options = ["vent1_isUpper", "vent1_isLower"]
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['upperOrLower1']
      }
    }),
    "vent2_isUpper": () => ({
      validate: () => {
        const options = ["vent2_isUpper", "vent2_isLower"]
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['upperOrLower2']
      }
    }),
    "vent3_isUpper": () => ({
      validate: () => {
        const options = ["vent3_isUpper", "vent3_isLower"]
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES['upperOrLower3']
      }
    }),
  };
};

export default useValidation;